import { MAP_TYPES } from "@deck.gl/carto";
import { CONNECTION } from "../config.js";
const ZOOM_OUT_SOURCE_ID = "zoomOutSource";

const source = {
  id: ZOOM_OUT_SOURCE_ID,
  connection: CONNECTION.connection,
  data: `WITH main as(
  SELECT bqcarto.quadkey.TOPARENT(bqcarto.quadkey.QUADINT_FROMQUADKEY(geo_id_origin), 11) as qk, part_of_day, day_of_week, geo_id_destination, SUM(n_visitors) as n_visitors
  FROM ${CONNECTION.project}.${CONNECTION.dataset}.${CONNECTION.origin_destination}  WHERE geo_id_destination = '{geoid}'
  GROUP BY qk, part_of_day, day_of_week, geo_id_destination
  )
  SELECT 
  bqcarto.quadkey.ST_BOUNDARY(main.qk) as geom,
  part_of_day,
  day_of_week,
  geo_id_destination,
  n_visitors
  FROM main`,
  type: MAP_TYPES.QUERY,
};

export default source;
